import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import agent from '../../agent'
import { native, appData, Crypt, changeStage, historyManager, checkMobile } from '../../utils/common'
import { PAGE_INFO } from '../../constants/pageInfo';
import Collapse from '@material-ui/core/Collapse';
import ACTS from '../../constants'
import { store } from '../../store';


const $ = window.$;

const mapStateToProps = state => {
    return {
      lastScrapDate: state.common.lastScrapDate,
      certifyOnOff: state.common.certifyOnOff,
      active: state.common.active
    }
};

const mapDispatchToProps = dispatch => ({
    onLoadScrapLastDate: () =>
        dispatch({ type: ACTS.LOAD_SCRAP_LAST_DATE, payload: agent.Common.loadLastDate()  }),
    onUpdateCertifyOnOff: certifyOnOff =>
        dispatch({ type: ACTS.UPDATE_CERTIFY_ON_OFF,  certifyOnOff  }),
    onLogout: () => dispatch({ type: ACTS.LOGOUT })
});


// 채널톡
let isFirst = true;
$(document).on("click", ".textLauncherIcon", function(){
    const chPlugin = $('#ch-plugin-script-iframe');

    if(isFirst){
        $(chPlugin[0].contentWindow.document).on("click", "div[name=close2]", function(e){
            if(!e.isTrigger) window.history.back();
        })
        isFirst = false;
    }

    historyManager.push(() => {
        if($(chPlugin[0].contentWindow.document).find("div[name=close2]").length){
            $(chPlugin[0].contentWindow.document).find("div[name=close2]").trigger("click");
        }
    })
})

class SideBar extends Component {
    constructor(props){
        super();
        this.state = {
            openId: this.getMenuId()
        }

        this.isApp = agent.getSessionInfo().isApp;
    }

    menuId = [
            {id: 'report', title: '경영실적', link: '/report/summary'},
            {id: 'manage', title: '자금관리', link: '/manage/summary'},
            {id: 'tax', title: '세금관리', link: '/tax/vat'},           
            {id: 'debt', title: '채권채무', link: '/debt/transType1'},
            {id: 'slip', title: '전표입력', link: '/slip/etc'},
            /* {id: 'alram', title: 'O2O알리미', link: ''}, */ 
            {id: 'setting', title: '설정'}];
    
    subMenuToggle = (id, link) => {
        if(!link){
            //alert('준비중입니다.');
            return;
        }

        if(this.state.openId === id){
            this.setState({openId: null}); 
        }else{
            this.setState({openId: id}); 
        }

        if(link) this.onSelectedMenu(link)
    }

    getMenuIcon = title => {
        let iconText = '';

        if(title === '경영실적'){
            iconText = <i className="fas fa-chart-line"></i>;
        }else if(title === '자금관리'){
            iconText = <i className="fas fa-briefcase"></i>;
        }else if(title === '세금관리'){
            iconText = <i className="fas fa-calculator"></i>;
        }else if(title === '채권채무'){
            iconText = <i className="fas fa-chart-pie"></i>;
        }else if(title === '전표입력'){
            iconText = <i className="fas fa-edit"></i>;
        }else if(title === 'O2O알리미'){
            iconText = <i className="fas fa-chalkboard-teacher"></i>;
        }else if(title === '설정'){
            iconText = <i className="fas fa-cogs"></i>;
        }

        return iconText;
    }

    // path로 현재 사용중 메뉴 확인
    getMenuId = () => {
        for(let i=0; i<this.menuId.length; i++){
            if(PAGE_INFO[this.menuId[i].id]){
                for(let j=0; j<PAGE_INFO[this.menuId[i].id].length; j++){
                    const m = PAGE_INFO[this.menuId[i].id][j];
                    if(m.path == document.location.pathname){
                        return this.menuId[i].id;
                    }
                }
            }
        }
    }

    subMenuMoveNew = (url) => {
        if(url === '')  window.Alert.info('준비중입니다.');
        else            {
            changeStage(url);
            this.props.onClose();
        }
    }

    onSelectedMenu = e => {        
        let active = e.split('/');
        active = active[active.length-1];
        
        if(active === "help"){
            this.props.onClose();
            
            $(".textLauncherIcon").click();
            return;
        }

        //if(active === 'card' || active === 'bank'){
        //   this.props.onMove(active)       
        //}
        if(!active){
            alert('준비중입니다.');
            return;
        }
        //onMoveBook(e);
        //window.location.href = e;
        changeStage(e);
        //store.dispatch(push(e));

        this.props.onClose();
    }

    onLogout = () => {
        this.props.onLogout();
    }
    
    onUpdateCertifyOnOff = () => {               

        native().loadData();
            
        // 데이터 조회 콜백
        window.cbQueryKeys = param => {
            if(param.result){ 
              console.log(appData('CERT', param.data).get())
                if(appData('CERT', param.data).get().length != 0){
                    this.props.onUpdateCertifyOnOff("등록완료");
                }else{
                    this.props.onUpdateCertifyOnOff("미등록");
                }
                //this.setState({ jasanLinkData: appData('JASAN', param.data).get(), certData: appData('CERT', param.data).get() });
                //this.setState({ complete: true });
        
            }
        }
      }
      
/*
    onUpdateCertifyOnOff = () => {               

        native().loadData();
            
        // 데이터 조회 콜백
        window.cbQueryKeys = param => {
            if(param.result){ 
               
                if(appData('JASAN', param.data).get().length != 0){
                    this.props.onUpdateCertifyOnOff("등록완료");
                }else{
                    this.props.onUpdateCertifyOnOff("미등록");
                }
                this.setState({ jasanLinkData: appData('JASAN', param.data).get(), certData: appData('CERT', param.data).get() });
                this.setState({ complete: true });
        
            }
        }
    }*/

    componentWillMount(){
        this.props.onLoadScrapLastDate();
        this.onUpdateCertifyOnOff();
    }

    render() {
        const { user, onClose } = this.props;
        
        let jasanOnOff = {display : 'none'};
        
        if(checkMobile() == "android") jasanOnOff = {display : ''};

        

        return (
            <div className="asideMenuWrapBox">
                <div className="asideMenuBody">
                    <div className="innHeader">
                        
                        <a className="top_btn log" style={{right:"5px",display:"none"}} onClick={() => this.subMenuMoveNew('')}>
                            <i className="far fa-bell fa-lg chatCount"><span className="msgCount" style={{ display: 0===0 ? 'none' : 'block' }}>0</span></i>                        
                        </a>
                        
                        <a className="top_btn menu" onClick={ onClose }><i className="fas fa-angle-left  fa-lg"></i></a>
                        
                        <h1>
                            <div className="bookTitle" style={{ width:"60%",fontWeight:"normal" }}>
                            { user.companyNm }<span className="guideLine">|</span>
                            { user.userNm } <span style={{ fontSize:"12px" }}>님</span>
                            </div>
                        </h1>
                    </div>

                    <div className="asideHalfMenu" style={jasanOnOff}>
                        <div className="halfMenu" onClick={() => this.subMenuMoveNew('/scrap')}>
                            <div className="menuName"><i className="fas fa-download"></i> 자동 조회</div>
                            <div className="script"> · 최근수집<span className="f_rt">{ this.props.lastScrapDate }</span></div>
                        </div>
                        <div className="halfMenu" onClick={() => this.subMenuMoveNew('/asset/list')}>
                            <div className="menuName"><i className="fa fa-cog"></i> 자산 설정</div>
                            <div className="script">
                                · 인증서 상태
                                <span className="altTxt">{ this.props.certifyOnOff }</span>                                                                
                                
                            </div>
                        </div>
                    </div>

                    <div className="asideSlideWrap">
                        {
                            this.menuId && this.menuId.map((d, idx) => {
                                return (
                                    <dl className="asideToggleMenu" key={ idx }>
                                        <dt className={ (this.state.openId == d.id) ? 'btnSummToggle on' : 'btnSummToggle' } onClick={() => this.subMenuToggle(d.id, d.link)}>
                                        { this.getMenuIcon(d.title) }
                                        { d.title }
                                           
                                        </dt>
                                        {
                                            PAGE_INFO && PAGE_INFO[d.id] &&
                                            <Collapse in={ (true) }>
                                            <dd>
                                                <ul>{PAGE_INFO && PAGE_INFO[d.id].map((d2, idx2) => (<li key={ idx2 } className={ d2.path == document.location.pathname ? 'on' : '' }><a href="javascript:;" onClick={ () => this.onSelectedMenu(d2.path) }>{d2.title}</a></li>))}</ul>	
                                            </dd>
                                            </Collapse>
                                        }
                                    </dl>
                                )
                            })
                        }
                    </div>
                    
                    <div className="asideBottom">
                        <a className="callCenter" onClick={() => this.onSelectedMenu('/help')}><i className="fas fa-headset  fa-lg"></i> 고객센터</a>
                        <a className="logout" onClick={() => this.onLogout()}><i className="fas fa-power-off  fa-lg"></i> 로그아웃</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);


// WEBPACK FOOTER //
// ./src/components/common/SideBar.js